import React from "react";
import { Box } from "@mui/material";

interface PageSectionProps {
  children: React.ReactNode;
  sx?: object;
}

const PageSection: React.FC<PageSectionProps> = ({ children, sx }) => (
  <Box sx={{ mb: 3, ...sx }}>{children}</Box>
);

export default PageSection;
